export default __webpack_public_path__ + "static/media/recordsIcon.16e6df06.png";